// frontend/src/hooks/useEquipmentViewer.ts
/**
 * React Query hook for equipment viewer data.
 */
import { useQuery } from '@tanstack/react-query';
import { equipmentCatalogApi } from '@/api/equipmentCatalog';
import type { EquipmentViewerFilters } from '@/types/equipmentCatalog';
import { CACHE_TIMES } from '@/config/cacheTimes';

export function useEquipmentViewer(filters?: EquipmentViewerFilters) {
  return useQuery({
    queryKey: ['equipment-viewer', filters],
    queryFn: () => equipmentCatalogApi.getViewerData(filters),
    staleTime: CACHE_TIMES.LIVE,
    retry: 2,
  });
}

export function useEquipmentCatalogCategories() {
  return useQuery({
    queryKey: ['equipment-catalog-categories'],
    queryFn: () => equipmentCatalogApi.getCategories(),
    staleTime: CACHE_TIMES.CONFIG, // categories rarely change
  });
}

export function useEquipmentCatalogBrands(categoryId?: string) {
  return useQuery({
    queryKey: ['equipment-catalog-brands', categoryId],
    queryFn: () => equipmentCatalogApi.getBrands(undefined, categoryId),
    staleTime: CACHE_TIMES.CONFIG, // brands rarely change
  });
}
